// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.report.RentalManagerExternalReportWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

interface SpamInquiryParams {
  comment?: string;
  controlHash: string;
  inquiryId: number;
  reporterEmail?: string;
}
interface SpamInquiryForConversationParams {
  comment?: string;
  conversationId: number;
  messageId: number;
  reporterEmail: string;
}

export const RentalManagerExternalReportWebApiHandler_spamInquiry_Path = '/api/web/v1/report/spamInquiry';

/**
 * Report an inquiry as spam using inquiryId for non authenticated users
 */
export const RentalManagerExternalReportWebApiHandler_spamInquiry = (
  getParams: SpamInquiryParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SpamInquiryParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerExternalReportWebApiHandler_spamInquiry_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerExternalReportWebApiHandler_spamInquiryForConversation_Path =
  '/api/web/v1/report/spamInquiryForConversation';

/**
 * Report an inquiry as spam using conversationId for non authenticated users
 */
export const RentalManagerExternalReportWebApiHandler_spamInquiryForConversation = (
  getParams: SpamInquiryForConversationParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SpamInquiryForConversationParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerExternalReportWebApiHandler_spamInquiryForConversation_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
